<template>
  <div class="ion-page">
    <ion-header>
      <ion-toolbar>
        <img class="logo" src="img/logo-large.png" />
        <ion-buttons slot="end">
          <ion-icon
            size="large"
            name="arrow-back"
            class="header-icon-end"
            @click="goToHome"
          />
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <h3 class="grey">¿Qué tipo de consulta necesitas?</h3>
      <ion-list>
        <ion-item
          v-for="item in techs"
          :key="item.title"
          button
          @click="viewDetail(item)"
        >
          <ion-icon
            slot="start"
            size="large"
            :src="item.icon"
            :style="item.color"
          />
          <ion-label>
            <h3>{{ item.title }}</h3>
            <p>{{ item.description }}</p>
          </ion-label>
        </ion-item>
      </ion-list>
    </ion-content>
  </div>
</template>

<script>
const techs = [
  {
    title: 'Consulta de cardiología',
    icon: 'img/icons/svg/1.svg',
    description:
      'Solicite aqui su cita con alguno de nuestros cardiólogos. Indique si la consulta es urgente, primera visita o revisión',
    color: 'color: #E63135',
    disabledDates: [1, 2, 6, 7],
    locations: [
      { id: 'GC', name: 'Gran Canaria' },
      { id: 'LZ', name: 'Lanzarote' },
      { id: 'TF', name: 'Tenerife' },
      { id: 'FV', name: 'Fuerteventura' },
    ],
  },
  {
    title: 'Chequeo cardiológico',
    icon: 'img/icons/svg/3.svg',
    description:
      'Si no padece usted del corazón pero quiere  hacerse un reconocimiento completo solicite aquí su cita',
    color: 'color: #F46529',
    disabledDates: [1, 2, 6, 7],
    locations: [
      { id: 'GC', name: 'Gran Canaria' },
      { id: 'LZ', name: 'Lanzarote' },
      { id: 'TF', name: 'Tenerife' },
      { id: 'FV', name: 'Fuerteventura' },
    ],
  },
  {
    title: 'Chequeo deportivo',
    icon: 'img/icons/svg/2.svg',
    description:
      'Si practica deporte de forma habitual, va a realizar una prueba deportiva en la que le exigen un reconocimiento médico, o simplemente quiere comprobar el estado de su corazón antes de iniciar una actividad deportiva solicite aquí su cita',
    color: 'color: #0CA9EA',
    disabledDates: [1, 2, 6, 7],
    locations: [
      { id: 'GC', name: 'Gran Canaria' },
      { id: 'LZ', name: 'Lanzarote' },
      { id: 'TF', name: 'Tenerife' },
    ],
  },
  //{
  //  title: 'Consulta de cirugía vascular',
  //  icon: 'img/icons/svg/5.svg',
  //  description:
  //    'Si necesita cita con un especialista en circulación venosa y arterial periférica, tiene problemas de varices, o necesita la opinión de un especialista en Cirugía vascular pida aquí su cita',
  //  color: 'color: #CE6296',
  //  disabledDates: [1, 3, 4, 6],
  //  locations: [
  //    { id: 'GC', name: 'Gran Canaria' },
  //    { id: 'LZ', name: 'Lanzarote' }
  //  ],
  //},
  {
    title: 'Consulta de neumología',
    icon: 'img/icons/svg/6.svg',
    description:
      'Si lo que necesita es una cita con un especialista en aparato respiratorio pida cita aquí',
    color: 'color: #78BD43',
    disabledDates: [1, 2, 4, 5, 6, 7],
    locations: [
      { id: 'GC', name: 'Gran Canaria' },
      { id: 'TF', name: 'Tenerife' },
      { id: 'TF', name: 'Tenerife' },
    ],
  },
  {
    title: 'Consulta de nefrología',
    icon: 'img/icons/svg/4.svg',
    description:
      'Si quiere una cita con un especialista en riñón y vías urinarias pida cita aquí',
    color: 'color: #FFD439',
    disabledDates: [1, 2, 4, 5, 6, 7],
    locations: [{ id: 'GC', name: 'Gran Canaria' }],
  },
  {
    title: 'Consulta de neurología',
    icon: 'img/icons/svg/10.svg',
    description:
      'Si necesita cita con nuestro especialista en Neurología pulse aquí',
    color: 'color: #3f51b5',
    disabledDates: [1, 2, 3, 5, 6, 7],
    locations: [{ id: 'GC', name: 'Gran Canaria' }],
  },
  {
    title: 'Consulta de aparato digestivo',
    icon: 'img/icons/svg/16.svg',
    description:
      'Si necesita cita con nuestro especialista en de digestivo pulse aquí',
    color: 'color: #9f1888',
    disabledDates: [1, 2, 3, 5, 6, 7],
    locations: [{ id: 'GC', name: 'Gran Canaria' }],
  },
  // {
  //   title: 'Consulta de neurocirugía',
  //   icon: 'img/icons/svg/14.svg',
  //   description:
  //     'Si necesita cita con nuestro especialista en Neurocirugía pulse aquí',
  //   color: 'color: #3f51b5',
  //   disabledDates: [1, 2, 3, 4, 6, 7],
  //   locations: [{ id: 'GC', name: 'Gran Canaria' }],
  // },
  //  {
  //  title: 'Medicina interna',
  //  icon: 'img/icons/svg/15.svg',
  //  description: 'Especialidad que se encarga de atender a enfermos cuyo diagnóstico es difícil, que se encuentran afectados por varias enfermedades o que presentan síntomas en varios órganos, aparatos o sistemas del organismo.',
  //  color: 'color: #9f1888',
  //  disabledDates: [1, 7],
  //  locations: [
  //    { id: 'GC', name: 'Gran Canaria' },
  //    { id: 'LZ', name: 'Lanzarote' },
  //  ],
  //},
    // {
    // title: 'Medicina general',
    // icon: 'img/icons/svg/15.svg',
    // description: 'Especialidad que se encarga de atender a enfermos.',
    // color: 'color: #9f1888',
    // disabledDates: [1, 2, 4, 6, 7],
    // locations: [
    //   { id: 'FV', name: 'Fuerteventura' },
    // ],
  // },
  {
    title: 'Unidad cardiometabólica',
    icon: 'img/icons/svg/17.svg',
    description:
      'Si tiene sobrepeso, tensión alta, colesterol o diabetes, o quiere cuidar su salud metabólica más allá del peso, solicite aquí su cita con la Dra. Angélica Laurín.',
    color: 'color: #3575AC',
    disabledDates: [1, 2, 3, 5, 6, 7],
    locations: [{ id: 'GC', name: 'Gran Canaria' }],
  },
  {
    title: 'Revisión preoperatoria',
    icon: 'img/icons/svg/8.svg',
    description:
      'Si se va a operar y necesita revisión preoperatoria con Electrocardiograma pida cita aquí',
    color: 'color: #412159',
    disabledDates: [1, 2, 6, 7],
    locations: [
      { id: 'GC', name: 'Gran Canaria' },
      { id: 'TF', name: 'Tenerife' },
    ],
  },
  {
    title: 'Analítica',
    icon: 'img/icons/svg/9.svg',
    description:
      'Para pedir cita par la realización de una analítica pida cita aquí',
    color: 'color: #E91E63',
    disabledDates: [1, 2, 6, 7],
    locations: [{ id: 'GC', name: 'Gran Canaria' }],
  },
  //{
  //  title: 'Servicio de ecografía',
  //  icon: 'img/icons/svg/12.svg',
  //  description:
  //    'Si necesita cita para la realización de ecografia de abdomen, tiroides, ecografia vascular, músculo esquelética, venosa ... pida cita aquí',
  //  color: 'color: #4ab8c3',
  //  disabledDates: [1, 7],
  //  locations: [{ id: 'GC', name: 'Gran Canaria' }],
  //},
  // {
  //   title: 'Test Covid-19',
  //   icon: 'img/icons/svg/13.svg',
  //   description: '',
  //   color: 'color: #4Fb8c1',
  //   disabledDates: [1, 7],
  //   locations: [{ id: 'GC', name: 'Gran Canaria' }],
  // },
]

export default {
  name: 'Specialties',
  data() {
    return {
      techs,
    }
  },
  methods: {
    goToHome() {
      this.$router.push('/')
    },
    async viewDetail(params) {
      localStorage.params = JSON.stringify(params)
      this.$router.push('detail')
    },
  },
}
</script>
[]
<style scoped>
.logo {
  width: 300px;
  margin-left: calc(50% - 150px);
}

.header-icon-end {
  margin-right: 20px;
  color: #4d206a;
}

ion-toolbar {
  --background: #ededed;
}

.grey {
  color: #373737;
}

ion-nav {
  margin-top: 70px;
}

ion-button {
  width: 80%;
  margin: 30px 10%;
}
</style>
